import { render, staticRenderFns } from "./ButtonPrimaryForward.vue?vue&type=template&id=3bdf1b27&scoped=true"
import script from "./ButtonPrimaryForward.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf1b27",
  null
  
)

export default component.exports